'use client';

import { ErrorPage } from '~containers/ErrorPage/ErrorPage';
import { ErrorPageProps } from '~containers/ErrorPage/ErrorPage.types';

export default function Error() {
  const props: ErrorPageProps = {
    title: 'Что-то пошло\n' + 'не так',
    image: {
      src: '/static/images/500.png',
      alt: '500 error',
    },
    button: {
      text: 'Перейти на главную',
      href: '/',
    },
  };

  return <ErrorPage {...props} />;
}
